module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gCDC1"))).then(() => parcelRequire('1iHdE'));